module.exports = __webpack_public_path__ + "img/random.582fcfc9.svg";